module.exports = "https://img.xiyuyouxi.com/saas/img/banner.34a60fe1.png";